module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_mobile_friendly_and_responsive.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_mobile_friendly_and_responsive.png
// module id = zmwS
// module chunks = 0